<style lang="scss" scoped>
$issue: #da3b3d;
$response: #327e07;

.referral-events {
	margin-left: 30px;
	border-left: 2px dashed #ccc;
	position: relative;
	&__company {
		margin-left: 15px;
		display: inline-block;
	}
	&__date {
		float: right;
		padding: 3px 0;
	}
	&__container {
		margin-left: 50px;
		&--issue {
			border-left: 5px solid $issue;
		}
		&--response {
			border-left: 5px solid $response;
		}
	}
	&__row {
		position: relative;
	}
	&__type {
		background-color: $grey--100;
		font-size: 0.9em;
		text-transform: uppercase;
		padding: 3px 10px;
		display: inline-block;
		border-radius: 4px;
		text-align: center;
		color: white;
		&--issue {
			background-color: $issue;
		}
		&--response {
			background-color: $response;
		}
		&--event {
			background-color: $response;
		}
	}
	&__avatar {
		text-transform: uppercase;
		border-radius: 4px;
		color: white;
		font-size: 1.5em;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		position: absolute;
		top: 0;
		left: -30px;
		&:last-child {
			&:before {
				content: "";
				position: absolute;
				left: 0;
				top: 0;
				background: red;
				width: 20px;
				height: 100%;
				margin-left: -5px;
			}
		}
	}
	&__alert {
		padding: 0px 18px;
	}
	& /deep/ .el-card__header {
		padding: 14px 40px;
		background: $grey--100;
	}
}
</style>

<template lang="pug">
.block
    .referral-events(v-if="$apollo.loading || formattedEvents.length")
        .referral-events__row(v-for="event in formattedEvents", :key="event.id")
            .referral-events__avatar(:style="{ 'background-color': event.color}")
                span {{ initials(event) }}
            el-card(:class="`referral-events__container--${event.type}`", :body-style="{ padding: '10px 40px' }").referral-events__container
                .clearfix(slot='header')
                    .referral-events__type(:class="`referral-events__type--${event.type}`")
                        span {{ event.type }}
                    .referral-events__company(v-if="multipleCompanies")
                        h4 ({{ event.company }})
                    .referral-events__date 
                        span {{ event.created_at | standard_datetime }} 
                        strong ({{ event.created_at | time_ago }}) 
                .referral-events__content
                    .referral-events__content--email(v-if="event.type == 'email'")
                        .timeline__subject
                            h4 {{ event.meta.subject || 'No subject' }}
                            span {{ event.meta.address || 'No email address' }}
                    p {{ event.payload }}
                el-alert.referral-events__alert(type="warning", v-show="event.blocker", :closable="false") This issue refers the integration back to the application.
                el-alert.referral-events__alert(type="error", v-show="event.hard_blocker", :closable="false") This issue means that we can no longer continue with this integration.
    empty(v-else) No referral events have been logged just yet
</template>

<script>
import gql from "graphql-tag";
import { uniq } from "lodash";

export default {
	props: {
		referralIds: String
	},

	computed: {
		multipleCompanies() {
			return uniq(this.ReferralEvents.map(r => r.id)).length > 1;
		},
		formattedEvents() {
			if (!this.ReferralEvents || !this.ReferralEvents.length) {
				return [];
			}
			let formattedEvents = this.ReferralEvents.map(event => {
				return {
					...event,
					color: this.colourFromString(event.user_id)
				};
			});

			return formattedEvents.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
		}
	},

	methods: {
		colourFromString(str) {
			var colors = [
				"#e51c23",
				"#e91e63",
				"#9c27b0",
				"#673ab7",
				"#3f51b5",
				"#5677fc",
				"#03a9f4",
				"#00bcd4",
				"#009688",
				"#259b24",
				"#8bc34a",
				"#afb42b",
				"#ff9800",
				"#ff5722",
				"#795548",
				"#607d8b"
			];

			var hash = 0;
			if (str.length === 0) return hash;
			for (var i = 0; i < str.length; i++) {
				hash = str.charCodeAt(i) + ((hash << 5) - hash);
				hash = hash & hash;
			}
			hash = ((hash % colors.length) + colors.length) % colors.length;
			return colors[hash];
		},
		initials(event) {
			const firstLetter = string => {
				return string.charAt(0);
			};

			let initials = "";

			if (event.first_name) {
				initials += firstLetter(event.first_name);
			}
			if (event.last_name) {
				initials += firstLetter(event.last_name);
			}

			return initials ? initials : 'W';
		}
	},
	apollo: {
		ReferralEvents: {
			query: gql`
				query ReferralEvents($caseIds: String) {
					ReferralEvents(caseIds: $caseIds) {
						id
						type
						payload
						created_at
						blocker
						hard_blocker
						company
						first_name
						last_name
						user_id
						meta
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					caseIds: this.referralIds
				};
			}
		}
	}
};
</script>
